import React from 'react'
import Skeleton from 'react-loading-skeleton'

const DeliveryCardSkeleton = () => {
  return <Skeleton width={'100%'} height={54} />
}

export default DeliveryCardSkeleton
